import Vue from "vue";

export const whoIsOutBus = Vue.observable({ open: false });

export function requestWhoIsOut() {
  whoIsOutBus.open = true;
}
